export default __webpack_public_path__ + "65761a3a6ebc9a8300e237e8b1736415.svg";